module.exports = __webpack_public_path__ + "static/fonts/notokr-light.251f03d.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/affiliatecard/font/notokr-light.woff2
// module id = YOpI
// module chunks = 0